/*🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
window.AS ||= {} as never;
window.o_global ||= {} as never;
window.o_util ||= {} as never;

/*🤫*/
export const { AS, o_global, o_util } = window;
